import { get } from 'lodash';

const root = state => get(state, 'AdjustmentState.adjustmentList');
export const getAdjustmentListData = state =>
  get(root(state), 'adjustmentListData', []);
export const getAdjustmentListDataError = state =>
  get(root(state), 'adjustmentListDataError', null);
export const getLoading = state => get(root(state), 'loading', false);
export const getPrintLoading = state => get(root(state), 'printLoading', false);
export const getFetchingSites = state =>
  get(root(state), 'fetchingSites', false);
export const getSelectedAdjustments = state =>
  get(root(state), 'selectedAdjustments', []);
export const getPrintLoadingError = state =>
  get(root(state), 'printLoadingError', null);
export const getFromDateMax = state => get(root(state), 'fromDateMax', null);
export const getToDateMin = state => get(root(state), 'toDateMin', null);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/state/adjustmentList/selectors.js